"use strict";

class PriceScheduleDetailsController {

    constructor($scope, $window, SSHttpService, SSConfigService, SSAlertService, SSUtilService, OTPService, SSAppService, SSAwsService, SSUserService, SSAnalyticsService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;
        self.SSAnalyticsService= SSAnalyticsService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.reverseSort = false;

        self.unit_status = 0;

        self.offset = 0;
        self.limit = 10;
        self.selected_units_count = 0;

        self.current = 1;
        self.jump_to_page = 1;

        self.pageChanged = function(newPage) {
            self.loadUnits(newPage);
        };

        self.PRICE_MAP = [
            {"id": "0", "value":  "Reserve Price"},
            {"id": "1", "value":  "Fixed Price"},
            {"id": "2", "value":  "Increase By Percentage"},
            {"id": "3", "value":  "Decrease By Percentage"},
            {"id": "4", "value":  "Increase By Price"},
            {"id": "5", "value": "Decrease By Price"},
        ];

        self.price_show = true;
        self.editby = [];
        self.editby['Price'] = true;

        self.types = self.SSConfigService.serverConfig.unit_types;
        self.categories = self.SSConfigService.serverConfig.unit_categories;
        self.price_types = self.SSConfigService.serverConfig.unit_price_types;

        self.param = {
            property_id: self.property.id
        };

        self.unitStatuses = [];
        self.edited_fields= [];

        self.editableStatus = [
            self.UNIT_STATUS_DRAFT,
            self.UNIT_STATUS_LISTED,
            self.UNIT_STATUS_SOLD,
            self.UNIT_STATUS_SPECIAL_RESERVED
        ];

        self.checked = 0;

        self.checkboxes = {
            checked: false,
            count: 0,
            items: {}
        };

        // Call 'getUnits()' in 'getUnitSchedule()' to map data
        // self.getUnits();
        self.getUnitSchedule();
        self.setPageOptions();

        jQuery('.datepicker').datepicker({                
            dateFormat: "dd/mm/yy"
        });
    }

    getUnits() {
        const self = this;

        if (!self.property.id)
            return;

        self.stacks = [];
        self.units = [];
        self.units_master = [];
        self.edited_units = [];
        self.firstWatch = null;

        let url = 'sec/developer/properties/' + self.property.id + '/units';
        let params = {
            offset: 0,
            limit: 1500 // Consider max value
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.stacks = response.data.stacks;

            let units = angular.copy(response.data.property_units);
            units = self.SSUtilService.getSortedUnits(units, false, 'named_id');
            self.units = angular.copy(units);

            // Total units count for pagination
            self.count = response.data.property_units.length;

            jQuery.each(self.units, function(i, unit) {
                self.checkboxes.items[unit.id] = false;
                self.formatUnitData(unit);
            });

            self.units_master = angular.copy(self.units);
            self.units_master_converted = angular.copy(self.units);

            // jQuery.each(self.units, function (i, item) {
            //     self.$scope.$watchCollection(function () {
            //         return self.units[i];
            //     }, function (newValue, oldValue) {

            //         if ( self.firstWatch=="20" ) {
            //             self.edited_units.push(newValue.id);
            //         }
            //     });
            // });

            self.loadUnits(undefined, self.units_master);
        });
    }

    // CLIENT SIDE PAGINATION
    loadUnits(page, units){
        const self = this;

        // if(self.unit_status && !filtered){
        //     self.filterUnitsByStatus(self.unit_status);
        // }

        if(page) {
            self.offset = (page * self.limit) - self.limit;
            self.current = page;
            self.jump_to_page = page;
        }

        if(units === null || units === undefined){
            if(self.isSearchApplied()){
                units = self.getFilteredUnits();
            }
            else{
                units = self.units_master;
            }
        }

        self.units = units.slice(self.offset, self.limit + self.offset);
        self.count = units.length;

        // SET 'CURRENT SELECTED UNITS' COUNT
        if(parseInt(self.limit) < parseInt(self.units.length)){
            self.selected_units_count = self.limit;
        }
        else{
            self.selected_units_count = self.units.length;
        }

        if(self.count == 0){
            return;
        }

        // SET TOTAL PAGES ARRAY FOR 'JUMP TO' FEATURE
        let total_pages = Math.ceil(self.count / self.limit);
        self.setTotalPagesOptions(total_pages);
    }

    sortData(column){
        const self = this;

        self.reverseSort = (self.sortColumn == column) ? !self.reverseSort : false;
        self.sortColumn = column;

        let sortedUnits = [];

        if(self.reverseSort){
            sortedUnits = _.sortBy(self.units_master, column).reverse();
        }
        else{
            sortedUnits = _.sortBy(self.units_master, column);
        }
        self.loadUnits(undefined, sortedUnits);
    }

    getSortClass(column){
        const self = this;

        if(self.sortColumn == column){
            return self.reverseSort ? 'fa fa-caret-down' : 'fa fa-caret-up';
        }
    }

    applySearch(){
        const self = this;

        var units = self.units_master;

        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
        }

        self.loadUnits(undefined, units);
        // Re-Assign CheckAll filter
        // self.toggleCheckAll();
    }

    isSearchApplied(){
        const self = this;

        if(!self.block_no_search && !self.unit_no_search && !self.floor_search && !self.unit_search && !self.category_search && !self.floor_plan_type_search
            && !self.name_search && !self.price_type_search && !self.price_search && !self.reserve_price_search
            && !self.new_reserve_price_search && !self.psf_search && !self.new_price_search && !self.new_psf_search
            && !self.status_search){
            return false;
        }else{
            return true;
        }
    }

    getFilteredUnits(){
        const self = this;

        let units = [];

        _.each(self.units_master, function(unit){

            if(self.block_no_search && !(unit.block_no && unit.block_no.toString().includes(self.block_no_search))){
                return;
            }
            if(self.unit_no_search && !(unit.named_id && unit.named_id.includes(self.unit_no_search))){
                return;
            }
            if(self.floor_search && !(unit.floor_no && unit.floor_no.toString().includes(self.floor_search))){
                return;
            }
            if(self.unit_search && !(unit.unit_no && unit.unit_no.toString().includes(self.unit_search))){
                return;
            }
            if(self.category_search && !(unit.formatted_category && unit.formatted_category.trim().toLowerCase().includes(self.category_search.trim().toLowerCase()))){
                return;
            }
            if(self.floor_plan_type_search && !(unit.formatted_floor_plan_type && unit.formatted_floor_plan_type.trim().toLowerCase().includes(self.floor_plan_type_search.trim().toLowerCase()))){
                return;
            }
            if(self.name_search && !(unit.name && unit.name.trim().toLowerCase().includes(self.name_search.trim().toLowerCase()))){
                return;
            }
            if(self.price_type_search && !(unit.formatted_price_type && unit.formatted_price_type.trim().toLowerCase().includes(self.price_type_search.trim().toLowerCase()))){
                return;
            }
            if(self.price_search && !(unit.price && unit.price.toString().includes(self.price_search))){
                return;
            }
            if(self.psf_search && !(unit.psf && unit.psf.toString().includes(self.psf_search))){
                return;
            }
            if(self.new_price_search && !(unit.new_price && unit.new_price.toString().includes(self.new_price_search))){
                return;
            }
            if(self.new_psf_search && !(unit.new_psf && unit.new_psf.toString().includes(self.new_psf_search))){
                return;
            }
            if(self.reserve_price_search && !(unit.reserve_price && unit.reserve_price.toString().includes(self.reserve_price_search))){
                return;
            }
            if(self.new_reserve_price_search && !(unit.new_reserve_price && unit.new_reserve_price.toString().includes(self.new_reserve_price_search))){
                return;
            }
            if(self.status_search && !(unit.formatted_status && unit.formatted_status.toLowerCase().includes(self.status_search.trim().toLowerCase()))){
                return;
            }
            
            units.push(unit);
        });

        return units;
    }

    // Statuses: ALL, LISTED, DRAFT, BOOKED etc
    filterUnitsByStatus(status){
        const self = this;

        self.unit_status = status;

        if(!status){
            self.loadUnits(undefined, self.units_master);
            return;
        }

        let units = [];

        jQuery.each(self.units_master, function(index, unit){
            if(unit.status == status){
                units.push(unit);
            }
        });

        // params: self.loadUnits(pageNum, filtered/sorted units);
        self.loadUnits(undefined, units);
    }

    formatUnitData(unit) {
        const self = this;

        unit.formatted_unit_no = self.SSUtilService.getFullUnitNumber(unit);

        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_type = self.SSConfigService.getUnitTypeName(unit.type);
        unit.formatted_category = self.SSConfigService.getUnitCategoryName(unit.category);
        unit.formatted_status = self.SSConfigService.getUnitStatusName(unit.status);
        unit.formatted_price_type = self.SSConfigService.getUnitPriceTypeName(unit.price_type);
        unit.formatted_floor_plan_type = unit.floor_plan ? unit.floor_plan : '';
        unit.actual_price = unit.price;

        let stack = self.findStack(unit.stack_id);
        if (stack) {
            unit.block_no = stack.block_no;
            unit.stack_name = stack.name;
        }

        // Map data from 'priceSchedule' to highlight updated units and to show new price
        unit.new_psf = null;
        unit.new_price = null;
        unit.has_schedule = false;

        try{
            if(self.scheduleDetails && self.scheduleDetails.length > 0){
                let schedule_detail = self.scheduleDetails[0].unit_price_schedule_details.find(x => x.unit_id == unit.id);
                if(schedule_detail){
                    if ((unit.price != schedule_detail.price) ||
                        ((unit.reserve_price || schedule_detail.reserve_price) // handle null case for reserve_price
                            && unit.reserve_price != schedule_detail.reserve_price)) {
                        unit.has_schedule = true;
                    }

                    unit.new_price = schedule_detail.price;
                    unit.new_reserve_price = schedule_detail.reserve_price;

                    unit.new_psf = unit.size_ft2 ? unit.new_price/unit.size_ft2 : null;
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

        return unit;
    }

    findStack(stackId) {
        const self = this;

        let stack = null;

        jQuery.each(self.stacks, function (i, _stack) {
            if (stackId == _stack.id) {
                stack = _stack;
                return false;
            }
        });

        return stack;
    }

    /**
     * Select or clear every (filtered) unit row to match the Select All state.
     *
     * Must be wired in the view via ng-model="ctrl.checkAll" + ng-change — never ng-click:
     * on checkboxes ng-click fires before ngModel writes the new state, so self.checkAll
     * would still hold the previous value and the toggle behaves inverted (WEB-3556).
     * Also called programmatically after self.checkAll is set explicitly (cancelChanges).
     *
     * @returns {void}
     */
    toggleCheckAll(){
        const self = this;

        self.checked = 0;
        // Uncheck all to apply new changes
        jQuery.each(self.units_master, function (index, unit) {
            self.checkboxes.items[unit.id] = false;
            self.edited_status = "";
        });

        let units = self.units_master;
        if(self.isSearchApplied()){
            units = self.getFilteredUnits();
        }

        if(self.checkAll){
            // All units checked
            jQuery.each(units, function (index, unit) {
                self.checkboxes.items[unit.id] = true;
                self.checked += 1;
            });
            self.edited_status = "Changes will be applied to " + self.checked + " rows";
        }
    }

    checkedAlert(unit) {
        const self = this;

        if(self.checkboxes.items[unit.id] == false){
            self.checkboxes.items[unit.id] == true;
            self.checked -= 1;
        }
        else if(self.checkboxes.items[unit.id] == true){
            self.checkboxes.items[unit.id] == false;
            self.checked += 1;
        }

        self.edited_status = "Changes will be applied to " + self.checked + " rows";
    }

    // getFloorPlans(){
    //     const self = this;

    //     let url = 'properties/' + self.property.id + '/floorplans';

    //     loading(true);
    //     self.SSHttpService.getAPIRequest(url).then(function (response) {
    //         loading(false);
    //         if (response instanceof Error) {
    //             self.SSAlertService.parseAndDisplayError(response);
    //             return;
    //         }

    //         self.floorPlans = response.data.floorplans;

    //         jQuery.each(self.floorPlans, function (i, status) {
    //             self.search_floorPlan.push({id: status.name, title: status.name});
    //         });

    //     });

    //     jQuery.each(self.SSConfigService.serverConfig.unit_statuses, function (i, status) {
    //         if (self.editableStatus.indexOf(status.id) != -1) {
    //             self.unitStatuses.push(status);
    //             self.select_status.push({id:status.name, title:status.name});
    //         }
    //     });
    // }

    cancelChanges() {
        const self = this;

        loading(true);

        self.edited_status = '';
        self.editable = !self.editable;
        self.edited_fields = [];

        self.units = angular.copy(self.units_master);

        self.SSAlertService.danger('Oops!', 'Your changes cancelled');
        self.changesApplied = false;

        // Mark check all as false before cancelling the changes
        self.checkAll = false;
        self.toggleCheckAll();

        loading(false);
    }

    applyChanges() {
        const self = this;

        self.SSAlertService.success('');

        self.param.unit_ids = [];

        // let filteredData = self.tableParams.filter() ? self.filter('filter')(self.units, self.tableParams.filter()) : self.units;

        let units = self.units_master;
        let checked_units = self.checkboxes.items;

        $.each(self.checkboxes.items, function(unit_id, checked) {
            if (checked) {
                let unit = units.find(x => x.id == unit_id);
                let unit_converted = self.units_master_converted.find(x => x.id == unit_id);

                if (unit) {
                    self.param.unit_ids.push(unit.id);
                    self.edited_units.push(unit.id);

                    switch (self.param.update_price_by) {
                        case "0":
                            unit.unsaved_reserve_price = self.param.reserve_price || 0; // Set reserve price 0 if empty
                            break

                        case "1":
                            unit.unsaved_price = self.param.price;
                            break;

                        case "2":
                            if(self.param.price !== "undefined" && self.param.price !== null && self.param.price !== "") {
                                let price = parseFloat(self.param.price);
                                let x = parseFloat(Number((price / 100) * unit_converted.price).toFixed(2));
                                let y = parseFloat(Number(unit_converted.price).toFixed(2));
                                unit.unsaved_price = x + y;
                            }
                            else {
                                unit.unsaved_price = self.param.price;
                            }
                            break;

                        case "3":
                            if (self.param.price !== "undefined" && self.param.price !== null && self.param.price !== "") {
                                let x = parseFloat(Number((self.param.price / 100) * unit_converted.price).toFixed(2));
                                let y = parseFloat(Number(unit_converted.price).toFixed(2));
                                unit.unsaved_price = y - x;
                            }
                            else {
                                unit.unsaved_price = self.param.price;
                            }
                            break;
                            
                        case "4":
                            if(self.param.price !== "undefined" && self.param.price !== null && self.param.price !== "") {
                                let y = parseFloat(Number(unit_converted.price).toFixed(2));
                                let price = parseFloat(self.param.price);
                                unit.unsaved_price = parseFloat(self.param.price) + y;
                            }
                            break;
                            
                        case "5":
                            if(self.param.price !== "undefined" && self.param.price !== null && self.param.price !== "") {
                                let y = parseFloat(Number(unit_converted.price).toFixed(2));
                                unit.unsaved_price = y - parseFloat(self.param.price);
                            }
                            break;

                        default:
                            console.log("Shouldn't be here! Please contact administrator!");
                            break;
                    }

                    self.formatUnitData(unit);

                    // let dirty_id = i + '_' + unit.id;

                    // if ($.inArray(dirty_id, self.edited_fields) === -1) {
                    //     self.edited_fields.push(dirty_id);
                    // }
                }
            } else{
                let unit = units.find(x => x.id == unit_id);
                if(unit){
                    unit.unsaved_price = unit.new_price;
                    unit.unsaved_reserve_price = unit.new_reserve_price;
                }

            }
        });

        if (self.param.unit_ids.length == 0) {
            self.SSAlertService.danger('Please select unit(s) to apply changes.');
            return;
        } 
        else if (!self.param.price && self.param.update_price_by !== "0") { // Allow user to save empty/null for reserve price
            self.SSAlertService.danger('Please provide correct value for at least one attribute (Price, Status, Name, Category, Type) to update unit(s).');
            return;
        }

        self.changesApplied = true;
    }

    saveUnits(units){

        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self.save_units_data = [];

            $.each(self.units_master , function(i, unit){
                let updated_reserve_price = unit.reserve_price;
                if(unit.unsaved_reserve_price !== null && unit.unsaved_reserve_price !== undefined){
                    updated_reserve_price = unit.unsaved_reserve_price; // Set unsaved_reserve_price price if not null
                }

                let units_data = {
                    "unit_id":unit.id,
                    "price": unit.unsaved_price ? unit.unsaved_price : unit.price,
                    "reserve_price": updated_reserve_price,
                };
                self.save_units_data.push(units_data);
            });

            let url = 'sec/developer/properties/'+ self.property.id +'/unit-price-schedules/' + self.data.schedule_id + '/details';
            let params = {
                unit_price: self.save_units_data,
            };

            loading(true);
            self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    if (response.code == 401) {
                        self.SSAlertService.danger('Oops!', 'Your session has expired. Please re-login to continue.');
                    } else if (response.code == 404) {
                        self.SSAlertService.danger(response.message);
                    } else if (response.code == 412) {
                        self.SSAlertService.danger('Invalid Params!', 'Please fill-in the valid information.');
                    } else {
                        self.SSAlertService.danger('Oops!', 'Please make changes and save');
                    }
                    return;
                }

                self.editable = !self.editable;
                self.scheduleDetails[0].unit_price_schedule_details = response.data.UnitPriceScheduleDetails;

                jQuery.each(self.units, function(i, unit) {
                    self.checkboxes.items[unit.id] = false;
                    self.formatUnitData(unit);
                });

                self.edited_fields=[];
                self.units_master_converted = angular.copy(self.units);

                self.SSAlertService.success('Success!', 'All data saved successfully.');

                self.changesApplied = false;
                self.progressUploadingFiles = false;
            });
        });

    }

    deleteUnit(unit_id){
        const self = this;

        if (!self.property.id) {
            return;
        }
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this unit?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/properties/' + self.property.id + '/' + unit_id + '/delete';
                loading(true);
                self.SSHttpService.postAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.danger('Error! :', response.message);
                        return;
                    }
                    else{
                        self.getUnits();
                        self.SSAlertService.success('Success! :', response.message);
                    }
                });
            }
        );
    }

    getUnitSchedule(){
        const self = this;

        let url = 'sec/developer/properties/' + self.data.property.id + '/unit-price-schedules/' + self.data.schedule_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data){
                self.scheduleDetails = response.data.unit_price_schedules;
                self.getUnits();
            }
        });
    }

    getFormattedDate(date){
        const self = this;

        try{
            if(date){
                return self.SSUtilService.formatUtcToLocalDate(date) + " " + self.SSUtilService.formatUtcToLocalTime(date);
            }
            else{
                return '--';
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    goBack(){
        const self = this;

        self.$window.location.href = '/developer/properties/' + self.property.named_id + '/price-schedules';
    }
    // showSelectedFields(field) {
    //     const self = this;

    //     self.editby=[];

    //     jQuery.each(self.OPTIONS_MAP, function (i, options){
    //         self.editby[options.value]=false;
    //     });
    //     if(field=="price"){
    //         self.price_show = true;
    //     }else {
    //         self.price_show = false;
    //     }
    //     self.editby[field]=true;
    // }

    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 5,
                name: '5 Rows'
            },
            {
                id: 10,
                name: '10 Rows'
            },
            {
                id: 20,
                name: '20 Rows'
            },
            {
                id: 30,
                name: '30 Rows'
            },
            {
                id: 40,
                name: '40 Rows'
            },
            {
                id: 50,
                name: '50 Rows'
            },
            {
                id: 100,
                name: '100 Rows'
            },
            {
                id: 200,
                name: '200 Rows'
            },
            {
                id: 400,
                name: '400 Rows'
            }
        ];
    }

    setTotalPagesOptions(TOTAL_PAGES){
        const self = this;

        self.TOTAL_PAGES_OPTIONS = [];

        for(var index = 0; index < TOTAL_PAGES; index++){
            self.TOTAL_PAGES_OPTIONS.push({id: index + 1, name: 'PAGE ' + (index + 1).toString() });
        }
    }

    exportPriceSchedule(scheduleId){
        const self = this;

        if(!scheduleId){
            console.log('Warning: Schedule Id not defined');
            return;
        }

        let url = self.SSHttpService.getApiURL('sec/developer/properties/' + self.property.id + '/price-list-export?unit_price_schedule_id=' + scheduleId);

        /** WEB-2898 DMS : Price List and Price Plans UI improvements
         * Need to send param timezone with local timezone offset **/
        let todayDate = new Date();
        let timezoneOffset = todayDate.getTimezoneOffset();
        timezoneOffset *= -1; // Get the offset from Local time
        let timezoneOffsetParam = (timezoneOffset >= 0 ? '+' : '-') + Math.abs(timezoneOffset);
        url+= (url.indexOf("?") > -1)? "&" : "?";
        url+="timezone_offset_minutes=" + timezoneOffsetParam;

        window.open(url, '_blank');

        self.SSAlertService.success("Success!", "Price schedule exported successfully");
    }
}

PriceScheduleDetailsController.$inject = ['$scope', '$window', 'SSHttpService', 'SSConfigService', 'SSAlertService', 'SSUtilService', 'OTPService', 'SSAppService', 'SSAwsService', 'SSUserService','SSAnalyticsService','SSConfirmationService'];
app.controller('PriceScheduleDetailsController', PriceScheduleDetailsController);

